<template>
  <div>
    <Breadcrumb :title="'Initial Issuance'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="row col-md-12 col-lg-12">
        <div class="input-group col-md-6 col-lg-6">
							<kendo-autocomplete id="SearchInvestment"
							                    class="form-control"
							                    v-model="ProgramInfoTemplate.parent.InvestmentID"
							                    :data-source="InvestmentDropdown"
							                    :data-text-field="'Title'"
							                    :filter="'contains'"
							                    :placeholder="'Search for Investment'"
							                    @select="onInvestmentAutoCompleteSelect"></kendo-autocomplete>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
							</div>
				</div>
        <div class="form-group col-md-6 col-lg-6 pr-0">
          <button
            class="btn btn-primary"
            style="float:right;"
            @click.prevent="addInvestment"
            >
						<span class="k-icon k-i-plus-outline"></span>&nbsp; Add New Investment
					</button>
					<button
            class="btn btn-secondary"
            style="float:right;"
            @click.prevent="downloadTemplate"
            >
						<span class="k-icon k-i-download"></span>&nbsp; Download Template
					</button>
					
					<button
             v-if="showAttachmentButton"
            class="btn btn-tertiary mr-3"
            style="float:right"
            @click.prevent="DocumentUploadForm"
            >
						<span class="k-icon k-i-clip"></span>&nbsp;Attach Documents
					</button>
        </div>
        
      </div>
    </div>
    <div class="row">
      <br>
    </div>
    <BaseAuditDropzone
      :id="'initialissuance'"
        ref="ParentFileUploaded"
      :acceptedFileTypes="SheetJSFT"
      @change="_change"
      @Remove="ClearForm"
      :File="inputfile"
      :UploadType="FileUploadType"
    ></BaseAuditDropzone>
    <br>
    <br>
    <div class="row no-gutters" v-show="displayPage">
      <ProgramForm
        ref="ProgForm"
        :disableGridToolbar="true"
        :disabled="false"
        :disableProgramID="false"
        :ProgramInfo="ProgramInfoTemplate"
        @UnitClassDeleteitem="UnitClassDeleteitem"
        @VestingDeleteitem="VestingDeleteitem"
      ></ProgramForm>
      <div style="width: 100%;">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label class="section-title">Partners</label>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-12">
          <BaseGrid
            :mode="'editform'"
            :config="PartnerGridConfig"
            :data="dataExcel"
            @EditItem="EditPartner"
            @DeleteItem="DeleteItemfromGrid"
          ></BaseGrid>
        </div>
      </div>
      </div>
    </div>

    <div v-if="displayPage">
      <div class="row">
        <br>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button type="button" id="btnSave" class="btn btn-primary" @click.prevent="SaveProgram">Save</button>
      </div>
      <div class="row">
        <br>
        <br>
      </div>
    </div>

    <div>
      <InitialIssuancePartnerForm
        :PartnerInfoFormConfig="PartnerInfoJSON"
        :PartnerUnitClassOptions="PartnerUnitClassOptions"
        :PartnerModalLabel="modalConfig"
        @UpdateParentGrid="UpdatePartnerGrid"
      ></InitialIssuancePartnerForm>
    </div>
    <div>
      <InitialIssuanceDocumentDropoffForm
      ref="InitialIssuanceDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedProgram"
    ></InitialIssuanceDocumentDropoffForm>
    </div>
  </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import DataPartnerConfig from "@/models/BaseModelPartner.js";
import DataIssuanceConfig from "@/models/BaseModelIssuance.js";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import InitialIssuancePartnerForm from "@/components/forms/InitialIssuancePartnerForm.vue";
import moment from "moment";
import ProgramForm from "@/components/forms/ProgramForm.vue";
import {
  ProgramInfoTemplate,
  PartnerGridConfig,
  InvestmentConfig,
  IssuanceBatchIdUpdateConfig
} from "./InitialIssuanceConfig.js";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapActions, mapState, mapGetters } from "vuex";
import { isNullOrUndefined } from "util";
import _ from "lodash";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";
//Document Component
import InitialIssuanceDocumentDropoffForm from "@/components/forms/InitialIssuanceDocumentDropoffForm.vue"; 
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";
import XLSX from "xlsx";
import sheetJSConfig from "@/configs/sheetJS.js";
//var loader;
export default {
  mixins: [apiUtil, funcUtil,VestingScheduleDatesMixin,DocumentManagerMixin],
  watch:{
    "InvId": function(newVal) {
      this.ProgramInfoTemplate.parent.InvestmentId=JSON.parse("[" + (newVal) + "]")
    }
  },
  data() {
    return {
      InvId:[],
      InvestmentID:[],
      InvestmentDropdown:[],
      data: "",
      inputfile: {
        UploadFile: {}
      },
      //UploadFile:excelfile,
      ProgramInfoTemplate: ProgramInfoTemplate,
      displayPage: false,
      validUnitClassOptions:[],
      DataPartner: [],
      DataPartnerConfig: DataPartnerConfig,
      DataIssuanceConfig: DataIssuanceConfig,
      PartnerUnitClassOptions: [],
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      PartnerGridData: [],
      FileUploadType: {
        AllowMultiple: "false"
      },
      bulkUploadAuditConfig: bulkUploadAuditConfig,
      //["SheetJS".split(""), "1234567".split("")],
      cols: [
        {
          name: "A",
          key: 0
        },
        {
          name: "B",
          key: 1
        },
        {
          name: "C",
          key: 2
        },
        {
          name: "D",
          key: 3
        },
        {
          name: "E",
          key: 4
        },
        {
          name: "F",
          key: 5
        },
        {
          name: "G",
          key: 6
        }
      ],
      SheetJSFT: sheetJSConfig.fileType,
      PartnerGridConfig: PartnerGridConfig,
      HeaderRow: "",
      dropdowns: {
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] },
        UnitPool:{ model: "", dataSource: []},
        UnitClass: { model: "", dataSource: [] },
      },

      dataExcel: [],

      PartnerInfoJSON: [],
      // UnitClassColumnOptions: [],
      pageErrors: [],
      // Document dropoff modal
      docModalConfig: {
        modalName: "Initial Issuance Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedProgram: {},
      //displayDropZone: false,
      newProgramId:null,
      issuanceCreationResponse:[],
      issuanceBatchGUId:[]
    };
  },
  components: {
    BaseGrid,
    InitialIssuancePartnerForm,
    ProgramForm,
    Breadcrumb,
    BaseAuditDropzone,
    InitialIssuancePartnerForm,
    InitialIssuanceDocumentDropoffForm
  },
  computed: {
    ...mapState("postModule", ["response"]),
   ...mapGetters("getModule", ["getAllItemFilter","withFilter","getLocalInputControls"]),
    showAttachmentButton(){
      return (this.newProgramId && this.issuanceCreationResponse)? true :false 
    }
  },
  created(){
    let result = this.withFilter(InvestmentConfig.list);
      this.InvestmentDropdown = result;
  },
  methods: {
    ...mapActions("postModule", ["CreateAllItems", "CreateJoinedItems","CreateItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
    _suppress(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },
    handleTmpUploadResponse(response){
        console.log(` INITIALISSUANCE HANDLING THE TEMP FILE ID: `, response);
    },
    downloadTemplate() {
     let token = localStorage.getItem("eum")
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("InitialIssuanceImport");
           let templateFileName = getFileName("InitialIssuanceImport");
            
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
    },
    addInvestment() {
      this.$router.push("/configuration/investment?InitailIssuace");
    },

    _drop(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const files = evt.BaseModelTransfer.files;
      if (files && files[0]) this._file(files[0],this.InvestmentID);
    },
    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) this._file(files,this.InvestmentID);
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    _file(file,InvestmentID) {
      /* Boilerplate to set up FileReader */
      try {
        //const XLSX = require("xlsx");
        const self=this;
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) 
          {
              binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary
          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Program  data */
          //const Progwsname = wb.SheetNames[0];
          const Progws = wb.Sheets["Program"];
          const Programdata = XLSX.utils.sheet_to_json(Progws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
        
          if (Programdata && Programdata.length) {
            this.displayPage = true;

            this.ProgramInfoTemplate.parent.Title = !isNullOrUndefined(
              Programdata[1][0]
            )
              ? Programdata[1][0]
              : null;

            this.ProgramInfoTemplate.parent.Alias = !isNullOrUndefined(
              Programdata[1][1]
            )
              ? Programdata[1][1]
              : null;           
                     
            this.ProgramInfoTemplate.parent.EIN = !isNullOrUndefined(
              Programdata[1][2]
            )
              ? Programdata[1][2]
              : null;

            this.ProgramInfoTemplate.parent.InvestmentId = InvestmentID;

            this.ProgramInfoTemplate.parent.FormationDate = self._getExcelPlatformCode(Programdata[1][3])
            
            this.ProgramInfoTemplate.parent.IncomeSource = !isNullOrUndefined(
              Programdata[1][4]
            )
              ? Programdata[1][4].split(",")
              : null;

            this.ProgramInfoTemplate.parent.StateSource = !isNullOrUndefined(
              Programdata[1][5]
            )
              ? Programdata[1][5].split(",")
              : null;

            this.ProgramInfoTemplate.parent.Note = !isNullOrUndefined(
              Programdata[1][6]
            )
              ? Programdata[1][6]
              : null;
          }

          /* Get Vesting  data */
          //const Vestingwsname = wb.SheetNames[1];
          const Vestingws = wb.Sheets["Vesting"];
          const Vestingdata = XLSX.utils.sheet_to_json(Vestingws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
          console.log(Vestingdata);
          if (Vestingdata && Vestingdata.length) {
            //if (this.HeaderRow != "") {
            this.displayPage = true;
            // data.sclassdataice(0, 17);
            // this.cols = classdata[0].map((x, i) => ({
            //     name: classdata[0][i],
            //     key: i
            // }));

            Vestingdata.splice(0, 1);

            let vestingArr = [];
            let count = 1;
            for (var i = 0; i < Vestingdata.length; i++) {
              var vestObj = {};
              //console.log(classdata[i])
              vestObj.UnitClass = !isNullOrUndefined(Vestingdata[i][0])
                ? Vestingdata[i][0]
                : null;
              vestObj.UnitType = !isNullOrUndefined(Vestingdata[i][1])
                ? Vestingdata[i][1]
                : null;
              vestObj.VestingType = !isNullOrUndefined(Vestingdata[i][2])
                ? Vestingdata[i][2]
                : null;
              vestObj.Year = !isNullOrUndefined(Vestingdata[i][3])
                ? Vestingdata[i][3]
                : null;
              vestObj.VestDate = self._getExcelPlatformCode(Vestingdata[i][4]);
            
              vestObj.Percentage = !isNullOrUndefined(Vestingdata[i][5])
                ? Vestingdata[i][5]
                : null;
              vestObj.Note = !isNullOrUndefined(Vestingdata[i][6])
                ? Vestingdata[i][6]
                : null;
              vestObj.vestingKey = count++;
              if (vestObj.VestingType.toLowerCase()=="standard" && vestObj.Year==0) {
                vestObj.Note='Standard Vesting Start Date'
              }
              vestingArr.push(vestObj);
            }
            this.validUnitClassOptions=_.sortBy(_.uniq(_.map(vestingArr, 'UnitClass')))
            console.log("unit Class Options",JSON.stringify(this.validUnitClassOptions));
            this.ProgramInfoTemplate.children.VestingSchedule = vestingArr;
          }

          /* Get class  data */
          //const classgwsname = wb.SheetNames[2];
          const Classws = wb.Sheets["Class"];
          const Classdata = XLSX.utils.sheet_to_json(Classws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
          console.log(Classdata);
          if (Classdata && Classdata.length) {
            this.displayPage = true;

            Classdata.splice(0, 1);

            let classArr = [];
            let count = 1;
            for (var i = 0; i < Classdata.length; i++) {
              var classObj = {};
              //console.log(classdata[i])
              classObj.UnitClass = !isNullOrUndefined(Classdata[i][0])
                ? Classdata[i][0]
                : null;
              classObj.PartnerType = !isNullOrUndefined(Classdata[i][1])
                ? Classdata[i][1]
                : null;
              classObj.Ownership = !isNullOrUndefined(Classdata[i][2])
                ? Classdata[i][2]
                : null;
              classObj.UnitPrice = !isNullOrUndefined(Classdata[i][3])
                ? Classdata[i][3]
                : null;
              classObj.InitialAwardDate = self._getExcelPlatformCode(Classdata[i][4]);
             
              classObj.SubjectToVesting = !isNullOrUndefined(Classdata[i][5])
                ? Classdata[i][5]
                : null;
              classObj.Note = !isNullOrUndefined(Classdata[i][6])? Classdata[i][6]: "";
              classObj.classKey = count++;
              classArr.push(classObj);
              // //Fill the UnitClassColumnOptions for DropDown Display in the Vesting Grid
              // this.UnitClassColumnOptions.push({
              //     "Option": classObj.UnitClass
              // })
            }
            // console.log(myArr);
            //console.log(ProgramInfoTemplate)
            this.ProgramInfoTemplate.children.UnitClass = classArr;
          }

          /* Get Partner  data */
          //const wsname = wb.SheetNames[3];
          const ws = wb.Sheets["Partner"];
          const data = XLSX.utils.sheet_to_json(ws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
          console.log(data);
          if (data && data.length) {
            //if (this.HeaderRow != "") {
            this.displayPage = true;
            // data.splice(0, 17);
            this.cols = data[0].map((x, i) => ({
              name: data[0][i],
              key: i
            }));

            data.splice(0, 1);

            let PartnerArr = [];
            let count = 1;
            for (let i = 0; i < data.length; i++) {
              let PartnerObj = {};

              PartnerObj.PartnerId = data[i][0];
              if (data[i][1])
                PartnerObj.FirstName = data[i][1].toString().trim();
              if (data[i][2])
                PartnerObj.MiddleName = data[i][2].toString().trim();
              if (data[i][3])
                PartnerObj.LastName = data[i][3].toString().trim();

              //logic to pick  form Partner full Name
              if (data[i][4]) {
                PartnerObj.PartnerName = data[i][4].toString().trim();
                PartnerObj.EntityName = data[i][4].toString().trim();
              } else {
                if (data[i][1])
                  PartnerObj.PartnerName = data[i][1].toString().trim();
                if (data[i][2])
                  PartnerObj.PartnerName =
                    PartnerObj.PartnerName + " " + data[i][2].toString().trim();
                if (data[i][3])
                  PartnerObj.PartnerName =
                    PartnerObj.PartnerName + " " + data[i][3].toString().trim();
              }
              if (data[i][5]) {
                PartnerObj.TSDocumentID = data[i][5].toString();
              }

              if (data[i][6]) {
                PartnerObj.UnitClass = this._firstLetterToUpper(data[i][6].toString().trim());
                let unitclassoptions = [];
                unitclassoptions.text = this._firstLetterToUpper(data[i][6].toString().trim());
                unitclassoptions.value = this._firstLetterToUpper(data[i][6].toString().trim());
                this.PartnerUnitClassOptions.push(unitclassoptions);
              }
              PartnerObj.UnitType = !isNullOrUndefined(data[i][7])? this._firstLetterToUpper(data[i][7]): "";
              PartnerObj.VestingType = !isNullOrUndefined(data[i][8])? this._firstLetterToUpper(data[i][8]): "";
              PartnerObj.Units = data[i][9];

              PartnerObj.DateIssued = self._getExcelPlatformCode(data[i][10]);

              PartnerObj.Notes = data[i][11];

              PartnerObj.PartnerKey = count++;
              PartnerArr.push(PartnerObj);
            }
            this.dataExcel = PartnerArr;

            this.RemoveDuplicates();
            this.validatePartnerData();
            this.CheckIfExistingPartner(false);

            var grid = $("#InitialIssuanceGrid").data("kendoGrid");

            grid.dataSource.data(this.dataExcel);
            console.log(JSON.stringify(this.dataExcel));
          }

          /* Update state */
          this.data = data;
          console.log(JSON.stringify(data));
        };
        reader.readAsArrayBuffer(file);
      } catch (ex) {
        console.log(ex);
        //this.$Progress.fail();
      }
    },
    onInvestmentAutoCompleteSelect(e) {
      this.InvestmentID.push(e.dataItem.Id);
    },
    DeleteItemfromGrid: function(e) {
      //e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
       this._ConfirmationPopup(
        "Do you want to delete this record?",
        "DELETE"
      ).then(response => {
        if (response.value) {
        let gview = window.$("#InitialIssuanceGrid").data("kendoGrid");
        let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
        //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
        //alert(JSON.stringify(dataItem));
        let objIndex = this.dataExcel.findIndex(
          obj => obj.PartnerKey == dataItem.PartnerKey
        );
        this.dataExcel.splice(objIndex, 1);
        let grid = $("#InitialIssuanceGrid").data("kendoGrid");
        grid.dataSource.data(this.dataExcel);
      }
      })
    }, 
    EditPartner: function(e) {
      e.preventDefault();
      this.modalConfig.modalName = "Edit Partner";
      this.modalConfig.modalAddorEdit = "edit";
      this.RemoveDuplicatesUnitClass();
      //alert("Edit button clicked from BaseGrid..");
      let gview = window.$("#InitialIssuanceGrid").data("kendoGrid");
      let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      //alert(JSON.stringify(dataItem));
      this.PartnerInfoJSON = { ...dataItem };
      window.$("#BaseModal").modal("toggle");
    },

    UpdatePartnerGrid: function(e) {
      let objIndex = this.dataExcel.findIndex(
        obj => obj.PartnerKey == this.PartnerInfoJSON.PartnerKey
      );
      this.dataExcel[objIndex] = this.PartnerInfoJSON;
      this.CheckIfExistingPartner(true);
      let grid = $("#InitialIssuanceGrid").data("kendoGrid");

      grid.dataSource.data(this.dataExcel);
    },

    CheckIfExistingPartner: function(fromEditModal) {
      let Partner = this.DataPartner;
      let excelData = this.dataExcel;
      let InvalidPartnerId = "";

      for (let i = 0; i < excelData.length; i++) {
        if (excelData[i].PartnerId) {
          let result = Partner.filter(function(obj) {
             if (obj.PartnerID) {
            return (
              
              obj.PartnerID.toString()
                .trim()
                .toLowerCase() ==
              excelData[i].PartnerId.toString()
                .trim()
                .toLowerCase()
            );
             }
          })[0];
          if (result) {
            excelData[i].IsNewPartner = "Existing";
            //excelData[i].PartnerId=result.Id;
          } else {
            excelData[i].IsNewPartner = "Invalid";
            //this._AlertPopup("PartnerID provided in template does not exist in our records.Please reverify and upload.","error");
            InvalidPartnerId =
              InvalidPartnerId + excelData[i].PartnerId.toString() + ", ";
          }
        } else {
          excelData[i].IsNewPartner = "New";
        }
      }
      //return true;
      if (InvalidPartnerId == "") {
        this.dataExcel = excelData;
      } else {
        if (!fromEditModal) {
          this.$refs.ProgForm.pageErrors.push(
            "PartnerID(s): " +
              InvalidPartnerId.substring(0, InvalidPartnerId.length - 2) +
              " does not exist in our database.Please provide a valid partner Id"
          );
        }
      }
    },

    ClearForm() {
      //this.pageErrors = [];
      this.$refs.ProgForm.pageErrors = [];
      this.dataExcel = []; //clear the BaseModelPartner grid
      //clear the ProgramInfo
      this.ProgramInfoTemplate = {
        parent: {
          Id: "",
          ProgramID: "",
          Title: "",
          Alias: "",
          EIN: "",
          FormationDate: "",
          InitialAwardDate: "",
          IncomeSource: "",
          FinalCloseDate: "",
          MultiClass: "",
          StateSource: "",
          IncomeSource: "",
          Note: "",
          InvestmentId: [],
          InvestmentTitle: "",
          InvestmentID: ""
        },
        children: {
          UnitClass: [],
          VestingSchedule: []
        }
      };

      //clear the Drop down Options for UnitClassColumnOptions as options would come from new file
      // this.UnitClassColumnOptions = []
      this.displayPage = false;
      //Document Forms
      //this.displayDropZone = false;
      this.newProgramId=null,
      this.issuanceCreationResponse=[]
      //this.$refs.InitialIssuanceDocumentMgr.resetDropZoneGrid();
    },

    RemoveDuplicates: function() {
      let isUnique = true;
      let arr = this.dataExcel;
      let flag = 0;
      let duplicate = [];
      let a = arr.reduce(function(accumulator, current) {
        if (checkIfAlreadyExist(current)) {
          flag = 1;
          duplicate.push([current]);
          return accumulator;
        } else {
          return accumulator.concat([current]);
        }

        function checkIfAlreadyExist(currentVal) {
          return accumulator.some(function(item) {
            return (
              item.PartnerId == currentVal.PartnerId && currentVal.PartnerId
              && item.UnitClass == currentVal.UnitClass && currentVal.UnitClass
              && item.UnitType == currentVal.UnitType && currentVal.UnitType
              && item.VestingType == currentVal.VestingType && currentVal.VestingType
            );
          });
        }
      }, []);

      if ((flag = 1 && duplicate.length > 0)) {
        //console.log(duplicate);
        this.$refs.ProgForm.pageErrors.push(
          "Please ensure Partner has unique combination of PartnerID ,Unit Class and Unit Type."
        );
        console.log(JSON.stringify(duplicate));
        isUnique = false;
      }

      return isUnique;
      //this.dataExcel=a;
    },

    RemoveDuplicatesUnitClass: function() {
      let arr = this.PartnerUnitClassOptions;
      let flag = 0;
      let duplicate = [];
      let UniqueUnitclass = arr.reduce(function(accumulator, current) {
        if (checkIfAlreadyExist(current)) {
          return accumulator;
        } else {
          return accumulator.concat([current]);
        }

        function checkIfAlreadyExist(currentVal) {
          return accumulator.some(function(item) {
            return item.value === currentVal.value;
          });
        }
      }, []);
      //this.dataExcel=a;
      this.PartnerUnitClassOptions = UniqueUnitclass;
    },
    validatePartnerData: function() {
      const self=this;
      let ClassApiData=self.validUnitClassOptions

      let InvalidpartnerID = [];
      let PartnerData = this.dataExcel.slice();
      let IsUnitsgreaterthan0 = true;
      let IsValidunitClass=true;
      let IsValidUnitType=true;
      let IsValidVestingType=true;
      PartnerData.forEach(partner => {
        if (parseInt(partner.Units) < 0) {
          IsUnitsgreaterthan0 = false;
          InvalidpartnerID = InvalidpartnerID + partner.PartnerId + ", ";
        }
      });
      if (!IsUnitsgreaterthan0) {
        InvalidpartnerID = InvalidpartnerID.substring(
          0,
          InvalidpartnerID.length - 2
        );

        this.$refs.ProgForm.pageErrors.push(
          `Units for Partners Id(s) - ${InvalidpartnerID} should be positive`
        );
      }
      InvalidpartnerID=[];
        PartnerData.forEach(partner => {
        if (ClassApiData.findIndex(f => f == partner.UnitClass)<0||partner.UnitClass =="" || isNullOrUndefined(partner.UnitClass)) {
          IsValidunitClass = false;
          InvalidpartnerID = InvalidpartnerID + partner.PartnerId + ", ";
        }
      });
      if (!IsValidunitClass) {
        InvalidpartnerID = InvalidpartnerID.substring(
          0,
          InvalidpartnerID.length - 2
        );

        this.$refs.ProgForm.pageErrors.push(
          `Unit Class for some Partners  is empty or invalid.`
        );
      }

       InvalidpartnerID=[];
        PartnerData.forEach(partner => {
           let unitTypeIndex = this.dropdowns.UnitType.dataSource.findIndex(f => f.Option == partner.UnitType)
        if (partner.UnitType =="" || isNullOrUndefined(partner.UnitType) ||unitTypeIndex<0) {
          IsValidUnitType = false;
          InvalidpartnerID = InvalidpartnerID + partner.PartnerId + ", ";
        }
      });
      if (!IsValidUnitType) {
        InvalidpartnerID = InvalidpartnerID.substring(
          0,
          InvalidpartnerID.length - 2
        );

        this.$refs.ProgForm.pageErrors.push(
          `Unit Type for some Partners is empty or invalid.`
        );
      }

      InvalidpartnerID=[];
        PartnerData.forEach(partner => {
            let vestingTypeIndex = self.dropdowns.VestingType.dataSource.findIndex(f => f.Option == partner.VestingType)
        if (partner.VestingType =="" || isNullOrUndefined(partner.VestingType) ||vestingTypeIndex<0) {
          IsValidVestingType = false;
          InvalidpartnerID = InvalidpartnerID + partner.PartnerId + ", ";
        }
      });
      if (!IsValidVestingType) {
        InvalidpartnerID = InvalidpartnerID.substring(
          0,
          InvalidpartnerID.length - 2
        );

        this.$refs.ProgForm.pageErrors.push(
          `Vesting Type for some Partners is empty or invalid.`
        );
      }

      return IsUnitsgreaterthan0&&IsValidVestingType&&IsValidUnitType&&IsValidunitClass;
    },
   
    //Called SavePartner() via CallSavePartner() to prevent async await error
    //TODO:- analyse for sharepoint API timeout issue
    CallSavePartner: function(programId) {
      this.SavePartner(programId);
    },
     SavePartner: function(programId) {
      //1.Create New Partners
      let self = this;
      console.log(this.dataExcel);
      let partnersAfterAdd = [];
      //var PartnerData={...this.dataExcel};
      let PartnerData = this.dataExcel.slice();
      let ApiPartnerData = [];
      let newPartners = [];
      const result = this.withFilter(DataPartnerConfig.list, "");
      let maxPartnerID = (result.length <= 0) ? 100001 : this._getIncrementalID(result, "PartnerID");
      maxPartnerID=maxPartnerID-1;
      PartnerData.forEach(partner => {
        if (partner.IsNewPartner == "New") {
          maxPartnerID=maxPartnerID+1;
          let newpartner = {};
          newpartner.FullName = partner.PartnerName;
          newpartner.TSDocId = partner.TSDocumentID;
          newpartner.EntityName = partner.EntityName;
          newpartner.FirstName = partner.FirstName;
          newpartner.MiddleName = partner.MiddleName;
          newpartner.LastName = partner.LastName;
          newpartner.PartnerID =maxPartnerID
          newPartners.push(newpartner);
          partner.PartnerId=maxPartnerID;
        }
      });
      let NewPartnerobject = {
        Partner: {
          config: this.DataPartnerConfig,
          createData: newPartners
        }
      };
      //this._createAllItems(NewPartnerobject).then(addnewpartner => {
      this.CreateAllItems(NewPartnerobject).then(addnewpartner => {
        console.log(addnewpartner);
        //Having a timeout of 1000 ms in order to avoid error in reading data after update
        //setTimeout(function () {

        //2.Fetch Matching Partner Data after saving to DB
        //self._getItems(DataPartnerConfig,{limit:5000}).then(response => {
        const partners = this.withFilter(DataPartnerConfig.list);
        partnersAfterAdd = partners;
        //3.Prepare The Issuance data to be inserted
         for (let i = 0; i < PartnerData.length; i++) {
          let result = partnersAfterAdd.filter(function(obj) {
             if (obj.PartnerID && PartnerData[i].PartnerId) {
            return (
              
             obj.PartnerID.toString()
                .trim()
                .toLowerCase() ==
                PartnerData[i].PartnerId.toString()
                  .trim()
                  .toLowerCase() 
            );
             }
          })[0];
          if (result) {
            var transactionData = {};
            transactionData.BusinessEvent = "Issuance";
            transactionData.ProgramId = programId;
            //transactionData.ProgramTitle = "Tishman Speyer Congressional Square Associates, L.P.";
            transactionData.ReceiverId = result.Id;
            transactionData.SenderId = null;
            //transactionData.ReceiverFullName = result.FullName;
            transactionData.UnitClass = PartnerData[i].UnitClass;
            transactionData.UnitType = PartnerData[i].UnitType;
            transactionData.VestingType = PartnerData[i].VestingType;
            transactionData.UnitPool = "New";
            transactionData.Status = "Pending";
            transactionData.Unit = PartnerData[i].Units;
            transactionData.TransactionDate = new Date(
              PartnerData[i].DateIssued
            );
            transactionData.Note = PartnerData[i].Notes;
            //Attach Vesting Dates
            let VestingScheduleResponse=this.ProgramInfoTemplate.children.VestingSchedule.filter(function(itm){
              return itm.UnitClass==transactionData.UnitClass
            });
            self._getVestingDates(transactionData,VestingScheduleResponse);
            
            self._updateHireDate(transactionData);
            
            ApiPartnerData.push(transactionData);
            //excelData[i].PartnerId=result.Id;
          }
        }
        console.log(ApiPartnerData);
        //4.Save to Issuance Table
        let InitialIssuanceobject = {
          Issuance: {
            config: self.DataIssuanceConfig,
            createData: ApiPartnerData
          }
        };

        //self._createAllItems(InitialIssuanceobject).then(
        self.CreateAllItems(InitialIssuanceobject).then(response => {
          this.ClearForm();
          //setTimeout(function () {
          //loader.hide();

          //Display Document Upload Form Once Initial Issuance Data Save is Successfull
          this.issuanceCreationResponse=response;
            let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
          let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload, true).then(function(response){
              self._AlertPopup("Initial Issuance data saved successfully", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });

          this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
          //AUDIT DOCUMENT UPLOAD END 
          
        });

        // });
        // },1000);
      });
    },
    UnitClassDeleteitem(e) {
      //alert("Unit Class Delete Event Triggered")
      //console.log(e.model)
      this._ConfirmationPopup(
        "Do you want to delete this record?",
        "DELETE"
      ).then(response => {
        if (response.value) {
          let gview = window.$("#ProgramClassInfoGrid").data("kendoGrid");
          let dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          console.log(dataItem);
          let row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
          gview.removeRow(row);
        }
      });
    },
    VestingDeleteitem(e) {
      //alert("Vesting Delete Event Triggered")
      //console.log(e)
      this._ConfirmationPopup(
        "Do you want to delete this record?",
        "DELETE"
      ).then(response => {
        if (response.value) {
          let gview = window.$("#ProgramVestingScheduleGrid").data("kendoGrid");
          let dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          console.log(dataItem);
          let row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
          gview.removeRow(row);
        }
      });
    },
    SaveProgram() {
      let self = this;
      console.log(this.ProgramInfoTemplate.parent)
      //1. Check for Program ID
      if (
        this.ProgramInfoTemplate.parent.ProgramID != "" &&
        this.ProgramInfoTemplate.parent.ProgramID != null
      ) {
        this._AlertPopup("ProgramID already exists", "warning");
        return;
      }
      //Read Data from Class and Vesting Grid and Insert in ProgramInfoTemplate
      this.ProgramInfoTemplate.children.UnitClass = this.GetCurrentGridData(
        "ProgramClassInfoGrid"
      );
      this.ProgramInfoTemplate.children.VestingSchedule = this.GetCurrentGridData(
        "ProgramVestingScheduleGrid"
      );

      //Fire Validation for Program Section
      if (this.$refs.ProgForm.Validate()) {
        //Validate Partners
        if (this.PartnerValidation()) {
          //Ask for Confrmation before processing
          this._ConfirmationPopup(
            "Do you want to Save the Information?",
            "save"
          ).then(result => {
            if (result.value) {
              //loader = this.$loading.show();
               this._APICrudPopup("APICrudpopup");
                console.log(this.ProgramInfoTemplate.parent)
        
             /** AUDIT DOCUMENT UPLOAD **/
          let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
          let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload,true)
            .then(response => {
              // self._AlertPopup("Partner Information saved successfully", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred", "info");
            })
            .finally(() => {
              //loader.hide();
            });
         // AUDIT DOCUMENT UPLOAD END 
             //Create New ProgramID
              const result = this.withFilter(BaseModelProgram.list, "");
              this.ProgramInfoTemplate.parent.ProgramID =(result.length <= 0) ? 300001 : this._getIncrementalID(result,"ProgramID");
              console.log("New ProgramID", this.ProgramInfoTemplate.parent.ProgramID);
              //Format Data for API
              this.ProgramInfoTemplate.parent.InvestmentId = this.ProgramInfoTemplate.parent.InvestmentId[0];
              this.ProgramInfoTemplate.parent.EIN = (this.ProgramInfoTemplate.parent.EIN)?this.ProgramInfoTemplate.parent.EIN.toString():null
              //this.ProgramInfoTemplate.parent.FormationDate=new Date(this.ProgramInfoTemplate.parent.FormationDate)
              console.log(this.ProgramInfoTemplate);
              let joinedItems = {
                joinedObject: {
                  parentConfig: BaseModelProgram,
                  childConfigs: [BaseModelVestingSchedule, BaseModelUnitClass]
                },
                createData: this.ProgramInfoTemplate,
                ParentKey: "ProgramId"
              };
              //Call Vuex Method
              try{
              this.CreateJoinedItems(joinedItems).then(response => {
                console.log("Program Creation returned data");
                console.log(response);
                if (response && response[0].vestingSchedule.ProgramId != undefined) {
                  this.newProgramId=response[0].vestingSchedule.ProgramId;
                  self.CallSavePartner(response[0].vestingSchedule.ProgramId);
                } else {
                  //loader.hide();
                  this._AlertPopup(
                    "Some Error Occured, Please Try Again",
                    "info"
                  );
                }
              })
              }
              catch(error)
              {
                this._AlertPopup(
                    "Some Error Occured, Please Try Again",
                    "info"
                  );
              }


            }
          });
        }
      } else {
        //this._InfoAlert("Some Validations have failed")
        //Display Partner Validations
        this.PartnerValidation();
      }
      //}
      //})

      //Start Partner Upload Stuffs here
    },
    getInputControls() {
        let self = this;
        let response = self.getLocalInputControls(BaseModelInputControl.list);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
        });
    },
    GetCurrentGridData(gridId) {
      const grid = $("#" + gridId).data("kendoGrid");
      let gridArray = [];
      let gridData = grid.dataSource.data();
      for (let i = 0; i < gridData.length; i++) {
        let element = gridData[i];
        gridArray.push(element);
      }
      return gridArray;
      //console.log(this.ProgramInfoTemplate)
    },
    PartnerValidation() {
      //Partner Validation
      this.RemoveDuplicates();
      this.validatePartnerData();
      this.CheckIfExistingPartner(false);
      let grid = $("#InitialIssuanceGrid").data("kendoGrid");
      grid.dataSource.data(this.dataExcel);
      return this.$refs.ProgForm.pageErrors.length > 0 ? false : true;
    },
    DocumentUploadForm() {
      let self=this;
      if (this.newProgramId > 0 && this.issuanceCreationResponse) {
        let selectedItem = [];
        let selectedRowCount=0;

        let partnerIdList= new Set();

        //Get Next Batch Id
        const result = this.withFilter(BaseModelDocument.list,"");
        let batchId = (result.length <= 0) ? 1 : this._getIncrementalID(result,"BatchGUID");
        this.issuanceBatchGUId.push(batchId)
        //let grid = $("#InitialIssuanceGrid").data("kendoGrid");
        _.forEach(this.issuanceCreationResponse, function(newIssuance) {
              let tempObj={};
              tempObj.Id=newIssuance.Id;
              partnerIdList.add(newIssuance.ReceiverId);
              tempObj.BatchGUID = self.issuanceBatchGUId.toString();
              selectedItem.push(tempObj);
          });
        console.log(selectedItem)

        // if (selectedRowCount<=1) {
        //   this._AlertPopup("Please Select Atleast 2 Rows","info");
        // }else{
          const batchConfig = {
          Issuance: {
            config: IssuanceBatchIdUpdateConfig,
            updateData: selectedItem
            }
          };

          //this.selectedProgram={};
          this.selectedProgram.ProgramId=this.newProgramId
          this.selectedProgram.PartnerId=null
          this.selectedProgram.PartnerIdList=[...partnerIdList].toString();
          this.selectedProgram.TransactionID=null
          this.selectedProgram.BusinessEvent="Issuance"
          this.selectedProgram.Type="batch"
          this.selectedProgram.BatchGUID=batchId;
          this.selectedProgram.batchConfig=batchConfig
          //this.selectedProgram.parentGridId="issuanceGrid"

          this.filterCondition.batchQuery=false;
          console.log(this.filterCondition.filter)
          this.filterCondition.filter = `BusinessEvent eq 'Issuance' and ProgramId eq ${
          this.newProgramId
        }`;
       this.$refs.InitialIssuanceDocument.$refs.InitialIssuanceDocumentMgr.resetDropZoneGrid();
        window.$("#docModal").modal("toggle"); 
      }
    },
    CreateInvestment(){
      let self=this;
            //check if Investment Exists 
            if (!isNullOrUndefined(this.ProgramInfoTemplate.parent.InvestmentID)) {
              //Check For Existing Record and Fetch the ID . If Does not Exist Show Error
              const query = {
                filter: "InvestmentID eq " + "'" + this.ProgramInfoTemplate.parent.InvestmentID + "'"
                }
                console.log(query)
              const result = this.withFilter(InvestmentConfig.list,query);
              if (result && result.length > 0) {
                this.ProgramInfoTemplate.parent.InvestmentId.push(result[0].Id);
              }else{
                //Alert Error
                 this._AlertPopup("Provided InvestmentID does not Exist","info");
              }
            }else if(!isNullOrUndefined(this.ProgramInfoTemplate.parent.InvestmentTitle)){
                //Check if Investment with Same Name Exits or Not
              //Create the Investment
                const result = this.withFilter(InvestmentConfig.list,"");
                let newInvestment={
                            InvestmentID:"",
                            Title:this.ProgramInfoTemplate.parent.InvestmentTitle
                            }
                newInvestment.InvestmentID = (result.length <= 0) ? 500001 : this._getIncrementalID(result,"InvestmentID");

                let createItem = { list:InvestmentConfig, payload:newInvestment };
                this.CreateItems(createItem).then((response) => { 
                  console.log("Investment Created ")
                  console.log(response)     
                  //self.ProgramInfoTemplate.parent.InvestmentId=[response.Id]
                  this.$refs.ProgForm.GetInvestmentlookUps(response.Id);
                  this.InvId=[response.Id]               
                })
            }else{
                this._AlertPopup("Investment Title is Empty","Info")
            }

    },
  },

  mounted() {
    //Vuex Method
      let response = this.withFilter(DataPartnerConfig.list);
      this.DataPartner = response;
      console.log("Partner Data ", JSON.stringify(response));
      this.getInputControls(); 
    //Clear the Initial Form Data if any
    this.ClearForm();
    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchInvestment");
  }
  // updated(){
  //     //alert("Updated event fired")
  //     if (this.pageErrors.length>0) {
  //         $('html, body').animate({scrollTop:$('#pageErrors').position().top}, 'slow');
  //     }

  // }
};
</script>

<style>
.dropzone {
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font-size: 16px;
  color: #646464;
  height: 300px !important;
  padding-top: 50px !important;
}
</style>
